import { MUTUAL_FUND_DETAIL_IMAGE_URL } from '../../constants'
import { KNOW_WHY_REASONS_HEADING_ID } from './constants'

export enum ReasonsBannerType {
  REASONS_IN_FORM = 'REASONS_IN_FORM',
  REASONS_ON_TRACK = 'REASONS_ON_TRACK',
  REASONS_OFF_TRACK = 'REASONS_OFF_TRACK',
  SIP_REASONS_OFF_TRACK = 'SIP_REASONS_OFF_TRACK',
  NO_SIP_REASONS_OFF_TRACK = 'NO_SIP_REASONS_OFF_TRACK',
  REASONS_OUT_OF_FORM = 'REASONS_OUT_OF_FORM',
  INVESTED_REASONS_OUT_OF_FORM = 'INVESTED_REASONS_OUT_OF_FORM',
  NOT_INVESTED_REASONS_OUT_OF_FORM = 'NOT_INVESTED_REASONS_OUT_OF_FORM',
  NO_INVESTMENT_REASONS_OFF_TRACK = 'NO_INVESTMENT_REASONS_OFF_TRACK'
}

const REASONS_IN_FORM_IMAGE_URL = '/know-why/reasons-in-form.svg'
const REASONS_ON_TRACK_IMAGE_URL = '/know-why/reasons-on-track.svg'
const REASONS_OFF_TRACK_IMAGE_URL = '/know-why/reasons-off-track.svg'
const REASONS_OUT_OF_FORM_IMAGE_URL = '/know-why/reasons-out-of-form.svg'

const reasonsBannerConfig: {
  [X in `${ReasonsBannerType}`]: { imgPath: string; accessibleTitle: string; line1: string; line2: string }
} = {
  [ReasonsBannerType.REASONS_IN_FORM]: {
    imgPath: REASONS_IN_FORM_IMAGE_URL,
    accessibleTitle: 'Reasons to Invest More / Continue SIP',
    line1: 'Reasons to',
    line2: 'Invest More / Continue SIP'
  },
  [ReasonsBannerType.REASONS_ON_TRACK]: {
    imgPath: REASONS_ON_TRACK_IMAGE_URL,
    accessibleTitle: 'Reasons to Invest More / Continue SIP',
    line1: 'Reasons to',
    line2: 'Invest More / Continue SIP'
  },
  [ReasonsBannerType.REASONS_OFF_TRACK]: {
    imgPath: REASONS_OFF_TRACK_IMAGE_URL,
    accessibleTitle: 'Reasons to Hold investment / Pause SIP',
    line1: 'Reasons to',
    line2: 'Hold investment / Pause SIP'
  },
  [ReasonsBannerType.SIP_REASONS_OFF_TRACK]: {
    imgPath: REASONS_OFF_TRACK_IMAGE_URL,
    accessibleTitle: 'Reasons to Pause your SIP',
    line1: 'Reasons to',
    line2: 'Pause your SIP'
  },
  [ReasonsBannerType.NO_SIP_REASONS_OFF_TRACK]: {
    imgPath: REASONS_OFF_TRACK_IMAGE_URL,
    accessibleTitle: 'Reasons to Hold your Investment',
    line1: 'Reasons to',
    line2: 'Hold your Investment'
  },
  [ReasonsBannerType.REASONS_OUT_OF_FORM]: {
    imgPath: REASONS_OUT_OF_FORM_IMAGE_URL,
    accessibleTitle: 'Reasons to Exit investment / Stop SIP',
    line1: 'Reasons to',
    line2: 'Exit investment / Stop SIP'
  },
  [ReasonsBannerType.NO_INVESTMENT_REASONS_OFF_TRACK]: {
    imgPath: REASONS_OFF_TRACK_IMAGE_URL,
    accessibleTitle: 'Reasons to Not Invest Now',
    line1: 'Reasons to',
    line2: 'Not Invest Now'
  },
  [ReasonsBannerType.INVESTED_REASONS_OUT_OF_FORM]: {
    imgPath: REASONS_OUT_OF_FORM_IMAGE_URL,
    accessibleTitle: 'Reasons to Exit this fund',
    line1: 'Reasons to',
    line2: 'Exit this fund'
  },
  [ReasonsBannerType.NOT_INVESTED_REASONS_OUT_OF_FORM]: {
    imgPath: REASONS_OUT_OF_FORM_IMAGE_URL,
    accessibleTitle: 'Reasons to Not Invest Now',
    line1: 'Reasons to',
    line2: 'Not Invest Now'
  }
}

export const ReasonsBanner = ({ bannerType }: { bannerType: `${ReasonsBannerType}` }) => {
  const config = reasonsBannerConfig[bannerType]
  return (
    <div className='w-full z-0 flex flex-col gap-3 bg-white min-h-[100px] px-5 pt-6 pb-4'>
      <div className='w-[56px] h-[56px]' aria-hidden='true'>
        <img
          className='w-auto h-full'
          src={`${MUTUAL_FUND_DETAIL_IMAGE_URL}${config.imgPath}`}
          alt=''
          aria-hidden='true'
        />
      </div>
      <h2
        id={KNOW_WHY_REASONS_HEADING_ID}
        tabIndex={-1}
        aria-label={config.accessibleTitle}
        className='m-0 text-[#232323] text-[18px] font-[400] leading-[140%] outline-none'
      >
        <span aria-hidden='true' className='text-[#6A6E6E]'>
          {config.line1}
        </span>
        <br />
        <span aria-hidden='true' className='font-[500]'>
          {config.line2}
        </span>
      </h2>
    </div>
  )
}
